import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epArticleStatus',
    standalone: false
})
export class ArticleStatusPipe implements PipeTransform {
    transform(value: string): string {
        let desc = '';
        if (!value) {
            return desc;
        }

        switch (value) {
            case 'A':
                desc = 'Added';
                break;
            case 'C':
                desc = 'Changed';
                break;
            case 'D':
                desc = 'Deleted';
                break;
            case 'N':
                desc = 'Not Changed';
                break;
            case 'X':
                desc = 'Deleted in a Previous Revision';
                break;
        }

        return desc;
    }
}
